import styled from "styled-components";

export const Align = styled.div`
    width: 100%;
    display: flex;
    margin: 40px;

    svg+div {
        margin-left: 20px;
    }
`;
